import {AppState} from '../store';

export const getTransactionData = (state: AppState) => state.transactions.data;

export const getPendingTransactions = (state: AppState) =>
  state.transactions.pending;

export const getMappedPendingTransactions = (state: AppState) => {
  const data = state.transactions.data;
  return state.transactions.pending.map((hash) => ({
    summary: data[hash].summary,
    hash,
  }));
};
